"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Events = require("../../util/dom-helpers/events");
function addEventListener(node, event, handler) {
    Events.on(node, event, handler);
    return {
        remove: function () {
            Events.off(node, event, handler);
        }
    };
}
exports.addEventListener = addEventListener;
